import { useState } from 'react'
import { Icon } from '@iconify/react'
import { NumberParam, StringParam, useQueryParam } from 'use-query-params'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { Button, Dropdown, Radio } from '@pepper/ui'

import s from './ReworkFilter.module.css'

export const ReworkFilter = () => {
  const [open, setOpen] = useState(false)
  const [filters, setFilters] = useQueryParam('rework', StringParam)
  const [_, setCurrentPage] = useQueryParam('currentPage', NumberParam)
  const [value, setValue] = useState<string | null>()

  const isChecked = (name: string | undefined) => {
    return name === value
  }

  const handleChange = (event: CheckboxChangeEvent) => {
    if (event.target.checked) {
      setValue(event.target.name)
    } else {
      setValue(undefined)
    }
  }

  const handleClose = () => {
    setFilters(undefined)
    setCurrentPage(0)
    setOpen(false)
  }

  const handleApply = () => {
    setFilters(value)
    setCurrentPage(0)
    setOpen(false)
  }

  const onVisibleChange = (visible: boolean) => {
    setValue(filters)
    setOpen(visible)
  }

  const appliedFilterText = (): string => {
    switch (String(filters)) {
      case '0':
        return 'Without Reworks'
      case '0+':
        return 'With Reworks'
      default:
        return ''
    }
  }

  const menu = (): JSX.Element => {
    return (
      <div className={s.wrapper}>
        <div className={s.title}>Reworks</div>
        <Radio
          checked={isChecked('0+')}
          name="0+"
          className={s.option}
          onChange={handleChange}
        >
          <div className={s.label}>With Reworks</div>
        </Radio>
        <Radio
          checked={isChecked('0')}
          name="0"
          className={s.option}
          onChange={handleChange}
        >
          <div className={s.label}>Without Reworks</div>
        </Radio>
        <div className={s.divider} />
        <div className={s.actions}>
          <Button className={s.actionBtn} type="primary" onClick={handleApply}>
            Apply
          </Button>
          <Button className={s.actionBtn} type="ghost" onClick={handleClose}>
            Reset
          </Button>
        </div>
      </div>
    )
  }

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      visible={open}
      onVisibleChange={onVisibleChange}
    >
      <Button size="small" className={s.button}>
        Reworks
        <div className={s.selected}>{appliedFilterText()}</div>
        <Icon
          icon="material-symbols:keyboard-arrow-down-rounded"
          width={16}
          height={16}
        />
      </Button>
    </Dropdown>
  )
}
